import { createContext, useContext, useState, useCallback } from "react";
import api from "@/lib/api";

const DataContext = createContext(null);

export function DataProvider({ children }) {
  const [menu, setMenu] = useState([]);
  const [categories, setCategories] = useState([]);
  const [settings, setSettings] = useState(null);

  const loadMenu = useCallback(async () => {
    const [m, c] = await Promise.all([api.get("/menu"), api.get("/categories")]);
    setMenu(m.data);
    setCategories(c.data);
  }, []);

  const loadSettings = useCallback(async () => {
    const { data } = await api.get("/settings");
    setSettings(data);
    return data;
  }, []);

  return (
    <DataContext.Provider
      value={{ menu, categories, settings, setSettings, loadMenu, loadSettings }}
    >
      {children}
    </DataContext.Provider>
  );
}

export const useData = () => useContext(DataContext);
